import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom"
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import style from "./reportCard.module.scss";
import { Link } from "react-router-dom"
import {
    competitionType,
    maxMargin,
    minMargin,
    priceIncrease,
    reactive,
    salesType,
    strategy
} from "../../../helpers/consts/variantEditModal"
import { Inventory, Pricing, productInfo, RobotData, withSortFeilds } from "../../../helpers/consts/reportConsts"
import { numberWithCommas } from "../../../helpers/actions/splitNumberWithComma";

const ReportCard = (props) => {

    //functions************************************
    const calculateLines = text => {
        if (text.length < 88) {
            return text
        } else {
            return text.substr(0, 80) + '...'
        }
    }

    return (
        <div className={style.wrapper}>
            <div className={style.newFlexWrapper}>
                <div className={`${style.flexItem} ${style.flexItem303}`}>
                    <div className={style.nameStyle}>
                        <Link className={style.name} style={{ textDecoration: "none" }} to={{ pathname: `https://www.digikala.com/product/dkp-${props.data.DKP}` }} target="_blank">
                            <div className={style.nameWrapper}>
                                <p
                                    className={style.realName}
                                    data-content={!props.data.newName.split(' | ')[1].includes('گارانتی')
                                        &&
                                        !props.data.newName.split(' | ')[1].includes('تضمین')
                                        ?
                                        '(' + toPersianNumber(props.data.newName.split(' | ')[1]) + ')'
                                        :
                                        ''}
                                >
                                    {calculateLines(toPersianNumber(props.data.newName))}
                                </p>

                            </div>
                        </Link>
                    </div>
                    {console.log(props, 'PROPSSSSS')}
                    <div className={style.DKPStyle}>
                        <p>DKPC - {toPersianNumber(props.data.DKPC)}</p>
                        <p className={style.DKPSeprator}></p>
                        <Link className={style.name} style={{ textDecoration: "none" }} to={{ pathname: `https://www.digikala.com/product/dkp-${props.data.DKP}` }} target="_blank">
                            <p>DKP - {toPersianNumber(props.data.DKP)}</p>
                        </Link>
                        <p className={style.DKPSeprator}></p>
                        <p>{props.data.supplierCode ? toPersianNumber(props.data.supplierCode) : '--'}</p>
                    </div>
                    <div className={style.DKPStyle}>
                        <p>{props.data.productGroup} برند {props.data.brand}</p>
                    </div>
                    {console.log(props.data, 'props.data.product[0]')}
                    <div className={style.channelPromotion}>
                    </div>
                </div>
                <div className={style.flexItem}>
                    <p className={style.priceStyle}>{props.data.salesStatus ? 'فعال' : 'غیرفعال'}</p>
                </div>
                <div className={style.flexItem}><p className={style.priceStyle}>{toPersianNumber(numberWithCommas(props.data.digikalaStock))}</p></div>
                <div className={style.flexItem}><p className={style.priceStyle}>{toPersianNumber(numberWithCommas(props.data.salesPrice))}</p></div>
                <div className={style.flexItem42}></div>
            </div>
        </div>
    )


}

export default withRouter(ReportCard);
